import { keepPreviousData, useQuery } from '@tanstack/react-query'

import {
  FetchOrganizations,
  type FetchOrganizationsParams,
} from '@/services/OrganizationService'

export const useOrganizations = (params: FetchOrganizationsParams) => {
  return useQuery({
    queryKey: ['organizations', params],
    queryFn: () => FetchOrganizations(params),
    // Hold the previous page on screen while the next loads, so paging through
    // the directory doesn't blank the list on every click.
    placeholderData: keepPreviousData,
  })
}
